import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import axios from "axios";
import { Selection } from "@/components/practitioner/champVisuel/ChampVisuelParameter";

export function CreateTimelineForm({
  patientId,
  setSelections,
  selectionRef,
  updateSelection,
}: {
  patientId: string;
  setSelections: React.Dispatch<React.SetStateAction<Selection[]>>;
  selectionRef: { current: { ZF: string[]; ZP: string[]; ZV: string[] } };
  updateSelection: () => void
}) {
  const formSchema = z.object({
    timeline: z
      .string()
      .min(2, { message: "Timeline must be at least 2 characters." }),
    selection: z.string().optional(), // Make selection optional
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      timeline: "",
      selection: selectionRef?.current
        ? JSON.stringify(selectionRef.current)
        : "null",
    },
  });

  async function onSubmit(values: z.infer<typeof formSchema>) {
    updateSelection();
    try {

      const adaptedData = {
        timeline : values.timeline,
        selection: JSON.stringify(selectionRef.current),
      };
      const response = await axios.post(
        `/practitioner/visualfield/${patientId}`,
        adaptedData
      );
      if (response.data) {
        const newSelection: Selection = response.data;
        setSelections((prevSelections: Selection[]): Selection[] => {
          return [...prevSelections, newSelection];
        });
      }
    } catch (error) {
      console.error("Erreur lors de la création de la timeline:", error);
    }
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full max-w-lg space-y-6"
      >
        <FormField
          control={form.control}
          name="timeline"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  placeholder="Nom de la Timeline"
                  {...field}
                  className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </FormControl>
              <FormDescription>
                Le nom de la timeline que vous voulez créer
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button
          type="submit"
          className="w-full py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600 focus:outline-none"
        >
          Créer une Zone de Travail
        </Button>
      </form>
    </Form>
  );
}
